<template>
  <div id="container" v-if="isReady">
    <div v-if="showQr">
      <qrScanner :subject="subject" :id="id" :code="code" @showForm="showUpdateForm = true; showQr = false"
        @close="showQr = false">
      </qrScanner>
    </div>
    <div v-else class="  flex w-full   p-5">
      <div class="vx-col flex items-center justify-center flex-col  mx-auto ">
        <vs-button @click="$emit('close')" size="large">Back</vs-button>
        <h1>{{ showTitle }}</h1>
 
        <vx-card>
          <info valueSize="26px" :label="subjectUpper + ' #'" :value="data.number" />
          <info valueSize="20px" label="Master Stock Code" :value="data.master" />
          <info valueSize="20px" label="Sub Stock Code" :value="data.sub" />
          <info valueSize="14px" label="Line Description" :value="data.lineDescription" />
          <div class="vx-row">
            <div class="vx-col w-1/2   mb-base">
              <info label="Company" :value="data.compId" />
              <info label="Stock" :value="data.stock" />
              <info label="Location" :value="inventory.locationName" />
              <info label="Unit" :value="data.unit" />

            </div>
            <div class="vx-col w-1/2 ">

              <info label="Size / Dimension" :value="data.sizeDimension" />
              <info label="Thickness" :value="data.thickness" />
              <info label="Zone" :value="inventory.zoneName" />
              <info label="Shelf" :value="inventory.shelfName" />
            </div>
          </div>
          <info valueSize="30px" label="Stock Balance" :value="inventory.stockBalance" />
        </vx-card>
        <vs-button v-if="showUpdateForm == false" class="mt-5" @click="showQr = true" size="large">SCAN QR
          CODE</vs-button>
      </div>
    </div>

    <div v-if="showUpdateForm">
      <updateform :subject="subject" :id="id" :code="code" @close="$emit('refreshData')"></updateform>
    </div>
  </div>
</template>
<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import { axiosMixin } from '../../mixin/axiosMixin';
import info from "@/views/inventory/info.vue"
import qrScanner from "./qrScanner.vue"
import updateform from "./updateForm.vue"
export default {
  mixins: [axiosMixin],
  components: {
    StatisticsCardLine,
    info,
    qrScanner,
    updateform,
  },
  props: {
    subject: {
      type: String,
      default: false,
    },
    id: {
      type: Number,
      default: '',
    }
  },
  data() {
    return {
      data: {},
      inventory: {},
      showQr: false,
      isReady: false,
      showUpdateForm: false,

    };
  },
  computed: {
    showTitle() {
      return this.subject == 'gr' ? 'Goods Received' : 'Goods Sent Out';
    },
    subjectUpper() {
      return this.subject.toUpperCase();
    },
    code() {
      return this.data.master + "|" + this.data.sub
    }

  },
  methods: {
    startLoading() {
      this.$vs.loading({
        container: '#container',
        scale: 0.6
      });
    },
    stopLoading() {
      this.$vs.loading.close('#container > .con-vs-loading');
    },
    getData() {
      this.startLoading();
      this.aronPost('getRecordDetails', { subject: this.subject, id: this.id }, '', '')
        .then(response => {
          if (response.status) {
            this.data = response.data.data;
            this.inventory = response.data.inventory;
            this.isReady = true;
          } else {
            this.errorAlert('Error', response.data.error)
          }

          this.stopLoading();
        })
        .catch(error => {
          console.log('error:', error);
          this.stopLoading();
        })

    }

  },
  mounted() {
    this.isReady = false;
    this.getData();
  },
  created() {

  }
};
</script>
